<template>
  <div>
    <sub-page-header :title="$t('roaming.title')" />
    <modal :show="showModal">
      <h3 slot="header" v-t="'roaming.saldo_limit_set'"></h3>
      <i18n path="roaming.saldo_limit_is" tag="p" slot="body">
        <span place="amount">{{ rcc.limit }}</span>
      </i18n>
      <button
        @click="hideModal"
        slot="footer"
        class="button w-100"
        v-t="'general.done'"
      ></button>
    </modal>
    <div class="container">
      <h1 class="page-heading center" v-t="'roaming.set_limit'"></h1>
      <p class="center" v-t="'roaming.info'"></p>
      <app-loading-ani v-if="rccFetchPending" />
      <template v-else>
        <threshold-slider
          :value="rccLimit"
          @decrement="decrementThreshold"
          @increment="incrementThreshold"
        ></threshold-slider>
        <div v-if="rccError" class="error-block">
          {{ $t(`api_errors.${rccError}`) }}
        </div>
        <button
          :disabled="!rccDirty || rccCommitPending"
          @click="commitRCC"
          class="button w-100 mt-4"
          v-t="'roaming.set_limit'"
        ></button>
        <div class="roaming-info-container mt-4">
          <div class="roaming-info-box">
            <div
              class="roaming-label"
              v-t="'roaming.data_transfer_quota'"
            ></div>
            <div class="roaming-data">
              <span class="bolder"
                >{{ rcc.fupCurrent }}/{{ rcc.fupLimit }}</span
              >
              <span class="min"> Mt</span>
            </div>
          </div>
          <div class="roaming-info-box">
            <div
              class="roaming-label"
              v-t="'roaming.saldo_limit_remaining'"
            ></div>
            <div class="roaming-data">
              <span class="bolder">{{ rccLeftFormatted }}</span>
              <span class="euro"> &euro;</span>
            </div>
          </div>
        </div>
        <a
          href="https://dna.fi/euroaming"
          target="_blank”"
          rel="noopener noreferrer"
          class="button button--white w-100 mt-4 center"
          v-t="'roaming.read_more_data_transfer_quota'"
        ></a>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import formatCurrency from '@/plugins/currency-formatter';
import SubPageHeader from '@/components/SubPageHeader';
import ThresholdSlider from '@/components/ThresholdSlider';
import AppLoadingAni from '@/components/AppLoadingAni';
import Modal from '@/components/Modal';
export default {
  data() {
    return {
      userInitiated: false,
      showModal: false,
    };
  },
  components: {
    SubPageHeader,
    ThresholdSlider,
    AppLoadingAni,
    Modal,
  },
  mounted() {
    this.$store.dispatch('roaming/fetchRCC');
  },
  methods: {
    decrementThreshold() {
      let newLimit = this.rccLimit - 5;
      if (newLimit < 0) {
        newLimit = 0;
      }
      this.$store.dispatch('roaming/changeRCCLimit', newLimit);
    },
    incrementThreshold() {
      let newLimit = this.rccLimit + 5;
      if (newLimit > 200) {
        newLimit = 200;
      }
      this.$store.dispatch('roaming/changeRCCLimit', newLimit);
    },
    async commitRCC() {
      const success = await this.$store.dispatch('roaming/commitRCC');
      if (success) {
        this.showModal = true;
      }
    },
    hideModal() {
      this.showModal = false;
    },
  },
  computed: {
    ...mapState('roaming', [
      'rcc',
      'rccDirty',
      'rccLimit',
      'rccError',
      'rccFetchPending',
      'rccCommitPending',
    ]),
    rccLeftFormatted() {
      return formatCurrency(this.rcc.limit - this.rcc.used, {
        includeZeros: false,
        includeEuro: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.roaming-info-container {
  position: relative;
  box-shadow: 0 1px 5px 0px rgba(#d4d4d4, 0.5);
  border-radius: 5px;
  background-color: white;
}
.roaming-info-box {
  padding: 2rem 1rem;
  background-color: white;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid $light-gray;
  &:first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  &:last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .roaming-data {
    font-size: 125%;
  }
}

.page-heading {
  @include font-black();
  font-size: 24px;
}
</style>
